import { MARKET } from './market';

export const MARKET_UNITS = MARKET === 'CAN' ? 'kilometers' : 'miles';
export const MARKET_UNITS_SHORT = MARKET === 'CAN' ? 'km' : 'mi';

const RADIUS_SLIDER_STEPS_MAP_CAN = [25, 50, 150, 200, 300, 500, 1000, 2000, 4000];
const RADIUS_SLIDER_DEFAULT_STEP_INDEX_CAN = 2;

const RADIUS_SLIDER_STEPS_MAP_USA = [25, 50, 100, 200, 300, 500, 1000, 2000, 4000];
const RADIUS_SLIDER_DEFAULT_STEP_INDEX_USA = 1;

export const RADIUS_SLIDER_STEPS_MAP =
  MARKET === 'CAN' ? RADIUS_SLIDER_STEPS_MAP_CAN : RADIUS_SLIDER_STEPS_MAP_USA;

export const RADIUS_SLIDER_DEFAULT_STEP_INDEX =
  MARKET === 'CAN' ? RADIUS_SLIDER_DEFAULT_STEP_INDEX_CAN : RADIUS_SLIDER_DEFAULT_STEP_INDEX_USA;
